'use client'

import {ProductGridContext} from '@local/stores/contexts'
import {Pastil, Button, Locale} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import React, {useContext} from 'react'

export const ProductGridCardComingSoon = ({retreat}) => {
	const {setNotifyPanel, setRetreat} = useContext(ProductGridContext)
	const handleClick = (e) => {
		e.preventDefault()
		e.stopPropagation()
		setRetreat(retreat)
		setNotifyPanel(true)
	}
	return (
		<>
			<Pastil
				className='mt-10'
				variant='grey'
				onClick={handleClick}>
				<Locale>Coming Soon</Locale>
			</Pastil>
			<Button
				tabIndex={0}
				type='button'
				onClick={handleClick}
				onKeyDown={e => { if (e.key === 'Enter') handleClick(e) }}
				as='div'
				variant='underlined'
				active
				className={cx(
					'uppercase font-medium pt-10 after:translate-y-2 overflow-visible',
					'hover:after:scale-x-0 hover:after:origin-right',
					'focus-visible:after:scale-x-0 focus-visible:after:origin-right',
				)}>
				<Locale>Notify Me</Locale>
			</Button>
		</>
	)
}
